module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAJCAYAAAAYcf3nAAAAAXNSR0IArs4c6QAAADdJREFUCB1jnDVr1jYGIGACEYyMjP9BNBgwzpkzxxnEYvn3799ikBQLExNTLEQSSjLCtLPAtAIAbLUON+kNkdYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/czuo.png
// module id = kGPK
// module chunks = 1